<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      
    </div>

    
  </div>
  
</template>

<script>

export default {
  components: {
    
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/marketingManagement/distribution/distributionSettings/distributionSettingsHome.vue